import {
  getLoading,
  getRoles,
  getToken,
  getTokenAvailable,
  getUnverifiedExpired,
  getUserId,
} from "./slice"
import { useSelector } from "@/base/store"

const useAuth = () => ({
  userId: useSelector(getUserId),
  roles: useSelector(getRoles),
  token: useSelector(getToken),
  isLoading: useSelector(getLoading),
  isAuthenticated: useSelector(getTokenAvailable),
  isUnverifiedExpired: useSelector(getUnverifiedExpired),
})

export default useAuth
